/** Minimal query state needed to keep a failed page on one truthful retry screen. */
export interface PageLoadQueryState {
  data: unknown;
  dataUpdatedAt: number;
  errorUpdatedAt: number;
  isEnabled: boolean;
  isError: boolean;
  isFetching: boolean;
  refetch: () => unknown;
}

export interface PageLoadState {
  failed: boolean;
  retrying: boolean;
  retry: () => void;
}

/**
 * React Query clears `isError` while a manual retry is running. Keep treating
 * that request as failed until newer data arrives, or the page briefly falls
 * back to blank/empty cards immediately after the person clicks Try again.
 */
export function pageLoadState(
  ...queries: readonly PageLoadQueryState[]
): PageLoadState {
  const hasUnresolvedError = (query: PageLoadQueryState): boolean =>
    query.isEnabled && (query.isError || query.errorUpdatedAt > query.dataUpdatedAt);
  const failed = queries.filter(hasUnresolvedError);

  return {
    failed: failed.length > 0,
    retrying: failed.some((query) => query.isFetching),
    retry: () => {
      for (const query of failed) void query.refetch();
    },
  };
}
